import styled from 'styled-components';

export const HorizontalLinksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0.5rem 0;

  > * {
    padding-right: 0.5rem;
  }

  > * + * {
    border-left: 1px solid;
    padding-left: 0.6rem;
  }
`;
